export default function DomotiqueGrid() {
  const solutions = [
    {
      title: 'Maison Connectée Complète',
      description: 'Installation complète d\'un système domotique pour votre maison. Intégration de tous vos équipements dans une solution centralisée et évolutive.',
      image: 'https://readdy.ai/api/search-image?query=luxury%20smart%20home%20living%20room%20with%20integrated%20automation%20system%2C%20modern%20minimalist%20interior%20design%20with%20ambient%20lighting%20controls%2C%20elegant%20touchscreen%20wall%20panel%2C%20sophisticated%20residential%20technology%2C%20clean%20white%20walls%20with%20wooden%20accents%2C%20professional%20home%20automation%20installation&width=600&height=400&seq=domotique-complete-002&orientation=landscape',
      features: ['Éclairage intelligent', 'Chauffage connecté', 'Volets automatisés', 'Sécurité intégrée']
    },
    {
      title: 'Contrôle Vocal',
      description: 'Intégration avec les assistants vocaux (Alexa, Google Home, Siri). Contrôlez votre maison par la voix pour un confort maximal et une accessibilité optimale.',
      image: 'https://readdy.ai/api/search-image?query=modern%20smart%20speaker%20device%20on%20minimalist%20white%20table%20in%20contemporary%20home%20interior%2C%20voice%20control%20assistant%20for%20home%20automation%2C%20clean%20professional%20product%20photography%2C%20elegant%20residential%20setting%20with%20soft%20ambient%20lighting%2C%20high-end%20smart%20home%20technology&width=600&height=400&seq=domotique-vocal-003&orientation=landscape',
      features: ['Compatible Alexa', 'Google Home', 'Apple HomeKit', 'Commandes vocales']
    },
    {
      title: 'Gestion Énergétique',
      description: 'Optimisez votre consommation d\'énergie avec un système intelligent. Suivi en temps réel, programmation automatique et réduction de vos factures énergétiques.',
      image: 'https://readdy.ai/api/search-image?query=digital%20energy%20monitoring%20dashboard%20on%20tablet%20screen%20showing%20consumption%20graphs%20and%20statistics%2C%20modern%20home%20energy%20management%20system%2C%20clean%20interface%20design%20with%20green%20efficiency%20indicators%2C%20professional%20smart%20home%20technology%2C%20minimalist%20white%20background&width=600&height=400&seq=domotique-energie-004&orientation=landscape',
      features: ['Suivi consommation', 'Programmation horaire', 'Détection présence', 'Économies garanties']
    },
    {
      title: 'Sécurité Avancée',
      description: 'Système de sécurité intelligent avec caméras HD, détecteurs de mouvement et alarmes connectées. Surveillance 24/7 et alertes en temps réel sur votre smartphone.',
      image: 'https://readdy.ai/api/search-image?query=modern%20security%20camera%20system%20mounted%20on%20white%20wall%20in%20contemporary%20home%2C%20sleek%20smart%20home%20surveillance%20equipment%2C%20professional%20security%20installation%20with%20motion%20sensors%2C%20clean%20minimalist%20interior%20design%2C%20high-tech%20home%20protection%20system&width=600&height=400&seq=domotique-securite-005&orientation=landscape',
      features: ['Caméras HD', 'Détection mouvement', 'Alertes instantanées', 'Enregistrement cloud']
    },
    {
      title: 'Scénarios Personnalisés',
      description: 'Créez des scénarios sur mesure pour automatiser votre quotidien. Réveil, départ, retour, soirée : chaque moment de votre journée devient plus confortable.',
      image: 'https://readdy.ai/api/search-image?query=smartphone%20app%20interface%20showing%20smart%20home%20automation%20scenarios%20and%20schedules%2C%20modern%20mobile%20application%20design%20for%20home%20control%2C%20clean%20user%20interface%20with%20scene%20buttons%20and%20timers%2C%20professional%20home%20automation%20software%2C%20minimalist%20white%20background&width=600&height=400&seq=domotique-scenarios-006&orientation=landscape',
      features: ['Scénarios multiples', 'Programmation facile', 'Activation automatique', 'Personnalisation totale']
    },
    {
      title: 'Installation Professionnelle',
      description: 'Notre équipe certifiée assure l\'installation complète de votre système domotique. Formation incluse pour une utilisation optimale de tous vos équipements.',
      image: 'https://readdy.ai/api/search-image?query=professional%20technician%20installing%20smart%20home%20automation%20system%20on%20white%20wall%2C%20expert%20electrician%20working%20on%20home%20automation%20panel%2C%20clean%20modern%20residential%20interior%2C%20professional%20installation%20service%2C%20technical%20expertise%20in%20home%20technology&width=600&height=400&seq=domotique-install-007&orientation=landscape',
      features: ['Techniciens certifiés', 'Installation rapide', 'Formation utilisateur', 'Support technique']
    }
  ];

  return (
    <section className="py-24 bg-gray-900">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-base font-semibold leading-7 text-orange-400">Nos Solutions</h2>
          <p className="mt-2 text-4xl font-bold tracking-tight text-white sm:text-5xl">
            Systèmes Domotiques sur Mesure
          </p>
          <p className="mt-6 text-lg leading-8 text-gray-400 max-w-3xl mx-auto">
            Des solutions domotiques adaptées à vos besoins et votre budget. Installation professionnelle dans tout le canton de Genève et en Suisse romande.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {solutions.map((solution, index) => (
            <div
              key={index}
              className="bg-gray-800 rounded-2xl overflow-hidden border border-gray-700 hover:border-orange-500/40 transition-all duration-300 hover:-translate-y-2"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={solution.image}
                  alt={solution.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-8">
                <h3 className="text-xl font-bold text-white mb-4">{solution.title}</h3>
                <p className="text-gray-400 mb-6 leading-relaxed">{solution.description}</p>
                <ul className="space-y-3 mb-6">
                  {solution.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-gray-300">
                      <i className="ri-check-line text-orange-400 text-xl mr-3"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
                <a
                  href="#contact"
                  className="inline-block w-full text-center bg-orange-500 text-white px-6 py-3 rounded-lg font-semibold hover:bg-orange-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Demander un devis
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
